import { Provider } from "@angular/core";
import { Routes } from "@angular/router";
import { routes } from "./intentRoutes";
import { IntentService } from "./services";

export function provideIntents(): Array<Provider>
{
    return [
        IntentService
    ];
}

export function intentRoutes(): Routes
{
    return routes;
}
